import { types } from "../action-types";

// import initialState from './appReducer';
const initialState = {
  loading: false,
  absLoading: true,
  user: {
    profile: {},
    name: "",
    email: "",
    workExperience: [],
    id: null,
    profession:[],
  },
  error: {},
  ABS:[],
  finisProf: false,
  pagination:null
};

const profileReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_PROFILE_INIT:
      return {
        ...state,
        loading: true,
      };
 case types.FETCH_PROFILE_REQUEST_SUCCESS: {
  const {
    Profiles,
    EmailAddress,
    name,
    _id,
    Professions,
    isOnboardingcompleted,
    isProfileCompleted,
    isCurrentEmployerPostedJob,
    isCurrentEmployerPostedBid,
    percentage,
    WizardFlow,
  } = action.payload;
  console.log('action.payload', action.payload);
  localStorage.setItem('userProfile', JSON.stringify(action.payload));

  return {
    ...state,
    loading: false,
    user: {
      ...state.user,
      profile: Profiles,
      email: EmailAddress,
      name,
      id: _id,
      profession: Professions,
      isOnboardingcompleted,
      isProfileCompleted,
      isCurrentEmployerPostedJob,
      isCurrentEmployerPostedBid,
      percentage,
      WizardFlow
    },
    error: {},
  };
}
    // Saving company details is the only place WizardFlow moves mid-session.
    // Without this the routes keep reading the value fetched before the save,
    // so a just-finished signup still looks unfinished and ValidateRoute bounces
    // it through /auth, which lands it on the dashboard.
    case types.SYNC_PROFILE_WIZARD_FLOW:
      return {
        ...state,
        user: { ...state.user, WizardFlow: action.payload },
      };
    case types.FETCH_PROFILE_REQUEST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case types.UPDATE_PROFILE_INIT:
      return {
        ...state,
        loading: true,
      };
    case types.UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
        user: { ...state.user, profile: action.payload.profile },
        error: {},
      };
    case types.UPDATE_PROFILE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case types.UPLOAD_PROFILE_PIC_INIT:
      return {
        ...state,
        loading: true,
      };
    case types.UPLOAD_PROFILE_PIC_SUCCESS:
      return {
        ...state,
        user: {
          ...state.user,
          profile: { ...state.user.profile, PictureUrl: action.payload },
        },
        loading: false,
        error: {},
      };
    case types.UPLOAD_PROFILE_PIC_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case types.FETCH_PROFILE_EXPERIENCE_SUCCESS:
      return {
        ...state,
        loading: false,
        user: { ...state.user, workExperience: action.payload },
        error: {},
      };
      case types.GET_ABS_ACCOUNTS:
        return {
          ...state,
          absLoading: true,
        };
      case types.GET_ABS_ACCOUNTS_SUCCESS:
        return {
          ...state,
          absLoading: false,
          ABS: action.payload?.data,
          pagination: action.payload?.pagination,
        };
      case types.GET_ABS_ACCOUNTS_FAILURE:
        return {
          ...state,
          absLoading: false,
          error: action.error,
        };      

    // case types.UPLOAD_RESUME_FAILURE:
    //   return {
    //     ...state,
    //     loading: false,
    //     error: action.error,
    //   };
    case types.PROFILE_RESET:
      return{
        ...state,
        user:{},
        loading: false,
      }
    case types.WIZARD_FINISHED:
      return{
        ...state,
        finisProf: true
      }
    default:
      return state;
  }
};

export default profileReducer;